import { getTrackingPageForRoute } from '@models/route-page-view-tracking';
import { createTrackingService } from '@services/factories';
import { ITrackingService } from '@services/TrackingService';
import { authenticationParamsContext } from '@stores/authentication/authentication-params-context';
import AuthenticationParamsStore from '@stores/authentication/authentication-params-store';
import {
    Action,
    Location
} from 'history';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';

interface Props extends RouteComponentProps {

}

export enum PageViewTrackerError {
    contextMissingError = 'This component must be used with the authenticationParamsContext'
}

/**
 * Tracks the page view events that occur inside the router
 * Requires: Context from authenticationParamsContext to be provided
 */
class PageViewTracker extends React.Component<Props> {
    static contextType = authenticationParamsContext;
    declare context: React.ContextType<typeof authenticationParamsContext>;

    // Probably good idea to dependency inject this later
    trackingService: ITrackingService = createTrackingService();

    unsubscribeHistoryListener: (() => void) | null = null;

    componentDidMount() {
        const {
            history,
            location
        } = this.props;

        if (!(this.context instanceof AuthenticationParamsStore)) {
            throw new Error(PageViewTrackerError.contextMissingError);
        }

        this.unsubscribeHistoryListener = history.listen(this.handleLocationChange);

        const id = this.context.authorizedRepresentativeId;
        if (id) {
            this.setIdFromParams(id);
        }
        this.handleInitialLocation(location);
    }

    componentWillUnmount() {
        this.unsubscribeHistoryListener?.();
    }

    setIdFromParams = (id: string) => {
        this.trackingService.setUserId(id);
    }

    handleInitialLocation = (location: Location) => {
        this.trackPage(location.pathname);
    };

    handleLocationChange = (location: Location, action: Action) => {
        this.trackPage(location.pathname);
    };

    private trackPage(route: string) {
        const clientTrackingPage = getTrackingPageForRoute(route);
        if (!clientTrackingPage) {
            // not sure if we track this event too
            console.warn('Unrecognised route for page view tracking');
            return;
        }

        this.trackingService.trackPageView(clientTrackingPage);
    }

    render() {
        return this.props.children ?? null;
    }
}

export default withRouter(PageViewTracker);



// WEBPACK FOOTER //
// ./src/components/page-view-tracker/index.tsx